var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWiki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2062_64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1683 7.28859L19.1372 0.25752C18.9731 0.0933398 18.7491 0 18.5156 0H6.21094C4.75705 0 3.57422 1.18283 3.57422 2.63672V27.3633C3.57422 28.8172 4.75705 30 6.21094 30H23.7891C25.2429 30 26.4258 28.8172 26.4258 27.3633V7.91016C26.4258 7.67051 26.3252 7.44545 26.1683 7.28859ZM19.3945 3.00076L23.425 7.03125H20.2734C19.7888 7.03125 19.3945 6.63697 19.3945 6.15234V3.00076ZM23.7891 28.2422H6.21094C5.72631 28.2422 5.33203 27.8479 5.33203 27.3633V2.63672C5.33203 2.15209 5.72631 1.75781 6.21094 1.75781H17.6367V6.15234C17.6367 7.60623 18.8196 8.78906 20.2734 8.78906H24.668V27.3633C24.668 27.8479 24.2737 28.2422 23.7891 28.2422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2734 12.4219H9.72656C9.24117 12.4219 8.84766 12.8154 8.84766 13.3008C8.84766 13.7862 9.24117 14.1797 9.72656 14.1797H20.2734C20.7588 14.1797 21.1523 13.7862 21.1523 13.3008C21.1523 12.8154 20.7588 12.4219 20.2734 12.4219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2734 15.9375H9.72656C9.24117 15.9375 8.84766 16.331 8.84766 16.8164C8.84766 17.3018 9.24117 17.6953 9.72656 17.6953H20.2734C20.7588 17.6953 21.1523 17.3018 21.1523 16.8164C21.1523 16.331 20.7588 15.9375 20.2734 15.9375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2734 19.4531H9.72656C9.24117 19.4531 8.84766 19.8466 8.84766 20.332C8.84766 20.8174 9.24117 21.2109 9.72656 21.2109H20.2734C20.7588 21.2109 21.1523 20.8174 21.1523 20.332C21.1523 19.8466 20.7588 19.4531 20.2734 19.4531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7578 22.9688H9.72656C9.24117 22.9688 8.84766 23.3623 8.84766 23.8477C8.84766 24.333 9.24117 24.7266 9.72656 24.7266H16.7578C17.2432 24.7266 17.6367 24.333 17.6367 23.8477C17.6367 23.3623 17.2432 22.9688 16.7578 22.9688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2062_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiki);
export default __webpack_public_path__ + "static/media/wiki.037d30d9a72ddae5db100890303790f1.svg";
export { ForwardRef as ReactComponent };